import React from 'react'
import styled, { css } from 'styled-components'
import theme from 'theme'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'

export type MarqueeCarouselProps = BoxProps & {
  items: React.ReactNode[]
  speedPerItem?: number
  gap?: string
  className?: string
  style?: React.CSSProperties
  numClones?: number
}

const DEFAULT_SPEED_PER_ITEM = 2 // 2s/item
const DEFAULT_NUM_CLONES = 2
function getTranslatePercent(numClones: number): number {
  return (100 * (numClones - 1)) / numClones
}

const MarqueeCarousel: React.FC<MarqueeCarouselProps> = ({
  items,
  speedPerItem = DEFAULT_SPEED_PER_ITEM,
  gap = theme.spacing.fix_400,
  numClones = DEFAULT_NUM_CLONES,
  ...props
}) => {
  const duration = items.length * speedPerItem * (numClones - 1)
  const loopItems = Array(numClones).fill(items).flat()
  const percent = getTranslatePercent(numClones)

  return (
    <Wrapper {...props}>
      <MarqueeTrack $duration={duration} $gap={gap} $percent={percent}>
        {loopItems.map((item, idx) => (
          <Box key={idx}>{item}</Box>
        ))}
      </MarqueeTrack>
    </Wrapper>
  )
}

const Wrapper = styled(Box)`
  position: relative;
  overflow: hidden;
  width: 100%;
  mask-image: linear-gradient(to right, transparent 0, #000 4%, #000 96%, transparent 100%);
  -webkit-mask-image: linear-gradient(to right, transparent 0, #000 4%, #000 96%, transparent 100%);
  white-space: nowrap;
  background: transparent;
`
const MarqueeTrack = styled(Box)<{ $gap: string; $duration: number; $percent: number }>`
  display: inline-flex;
  align-items: center;
  width: max-content;
  will-change: transform;
  animation: ${({ $duration }) => css`
    marquee ${$duration}s linear infinite
  `};
  gap: ${({ $gap }) => $gap};

  ${({ $percent }) => css`
    @keyframes marquee {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-${$percent}%);
      }
    }
  `}
  &:hover {
    animation-play-state: paused;
  }
`

export default MarqueeCarousel

